// TypeScript interfaces for get_timeseries_data tool call parameters
import { Formula } from "../../types/formula";

// Enum for time range type
export enum TimeRangeType {
  Relative = "relative",
  Absolute = "absolute"
}

// Enum for time window units
export enum TimeWindow {
  Minutes = "Minutes",
  Hours = "Hours",
  Days = "Days"
}

// Enum for metric types
export enum MetricType {
  Metric = "metric",
  Trace = "trace",
  Logs = "logs",
  KubernetesResource = "kubernetes_resource"
}

// Enum for aggregation types
export enum Aggregation {
  Sum = "sum",
  Count = "count",
  Min = "min",
  Max = "max",
  Avg = "avg",
  P50 = "p50",
  P90 = "p90",
  P95 = "p95",
  P99 = "p99"
}

// Time configuration for the time series data
export interface TimeConfig {
  // Type of time range (relative or absolute)
  type: TimeRangeType;
  
  // Fields for relative time range
  time_period?: number;
  time_window?: TimeWindow;
  
  // Fields for absolute time range
  start_time?: string; // RFC3339 format (e.g., '2024-12-12T14:27:22Z')
  end_time?: string;   // RFC3339 format (e.g., '2024-12-12T14:27:22Z')
}

// Single metric request configuration
export interface SingleMetricRequest {
  type: MetricType;
  metricName?: string; // Required if type is 'metric'
  aggregation: Aggregation;
  filters?: Record<string, string[]>;
  excludeFilters?: Record<string, string[]>;
  splits?: string[];
  regexes?: string[];
  excludeRegexes?: string[];
  bucketSize?: number;
  shouldNotReturn?: boolean;
  formulaIdentifier?: string;
  jsonPath?: string;
}

// Main request structure for multi-metric chart data
export interface GetTimeSeriesRequest {
  time_config: TimeConfig;
  timeseries: SingleMetricRequest[];
  formulas?: Formula[];
}

// Response structure from the tool
export interface TimeSeriesResponse {
  startTime: number;
  endTime: number;
  metricSpecifiers: any[]; // Will be transformed to MetricSpecifier[] from MultiMetoroMetricsCharts
  title?: string;
  formulas?: Formula[];
} 